import { render, staticRenderFns } from "./BangTinhTienTraCoc.vue?vue&type=template&id=a67d3ba2"
import script from "./BangTinhTienTraCoc.vue?vue&type=script&lang=js"
export * from "./BangTinhTienTraCoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports